export default __webpack_public_path__ + "static/media/info.icon.cd72b849.svg";